import React, { useEffect, useState, useCallback }  from 'react';
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import "./index.scss";

import SkeletonLoader from "../../../../../ui/SkeletonLoader";

import { useScanInfoContext } from "../../../../../../pages/ScanInfo/ScanInfoContext";

import { useSelector, useDispatch } from 'react-redux';
import { getRiskFindingStats } from "../../../../../../store/actions/thirdPartyRiskAction";
import { formatNumber } from "../../../../../../utils/util";

const RiskFindings = () =>{

    const riskFindingStatsResponse = useSelector((state) => state.thirdPartyRisk.riskFindingStats);

    const {
        domainId,
        scanId,
        organizationId,
        triggerStatsFetch,
        setTriggerStatsFetch,
    } = useScanInfoContext();

    const dispatch = useDispatch();

    const [riskFindingsLoading, setRiskFindingsLoadings] = useState(false);
    const [riskFindingStats, setRiskFindingsStats] = useState(null)

    const fetchRiskFindings = useCallback(() => {
        setRiskFindingsLoadings(true);
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`;
        dispatch(getRiskFindingStats(params))
    },[organizationId, domainId, scanId, dispatch])

    useEffect(()=>{
        if (triggerStatsFetch) {
            fetchRiskFindings();
            setTriggerStatsFetch(false);
        }
    },[triggerStatsFetch, setTriggerStatsFetch, fetchRiskFindings])

    useEffect(()=>{
        if(riskFindingStatsResponse !== null) {
            setRiskFindingsLoadings(false)
            setRiskFindingsStats(riskFindingStatsResponse)
        }
    },[riskFindingStatsResponse])

    return (
        <div className="bg-white-with-shadow p-4 h-100 mt-4">
            {
                riskFindingsLoading ?
                <SkeletonLoader type={"line"} count={7} currentPage={"digitalfootprint"} />
                :
                <motion.div
                    className="h-100"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                >
                    <div className="risk-findings-container">
                        <h4 className="risk-findings-heading">Risks Findings</h4>
                        <Row>
                            <Col lg={10}>
                                <div className="findings-type-container">
                                    <h4 className="sub-heading">Application Vulnerabilities</h4>
                                    <Row>
                                        <Col lg={3}>
                                            <div className="footprint-status w-100">
                                                <p className="footprint-heading">CVEs</p>
                                                <p className="footprint-count">{formatNumber(riskFindingStats?.stats?.domain_risk_findings?.application_vulnerabilities?.cves?.total)}</p>
                                            </div>
                                        </Col>
                                        <Col lg={9}>
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="footprint-status critical">
                                                    <p className="footprint-heading">Criticals</p>
                                                    <p className="footprint-count">{formatNumber(riskFindingStats?.stats?.domain_risk_findings?.application_vulnerabilities?.cves?.critical)}</p>
                                                </div>
                                                <div className="footprint-status high">
                                                    <p className="footprint-heading">High</p>
                                                    <p className="footprint-count">{formatNumber(riskFindingStats?.stats?.domain_risk_findings?.application_vulnerabilities?.cves?.high)}</p>
                                                </div>
                                                <div className="footprint-status medium">
                                                    <p className="footprint-heading">Medium</p>
                                                    <p className="footprint-count">{formatNumber(riskFindingStats?.stats?.domain_risk_findings?.application_vulnerabilities?.cves?.medium)}</p>
                                                </div>
                                                <div className="footprint-status low">
                                                    <p className="footprint-heading">Low</p>
                                                    <p className="footprint-count">{formatNumber(riskFindingStats?.stats?.domain_risk_findings?.application_vulnerabilities?.cves?.low)}</p>
                                                </div>
                                            </div>                                    
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col lg={2}>
                                <div className="findings-type-container">
                                    <h4 className="sub-heading">Network Threats</h4>
                                    <div className="footprint-status w-100">
                                        <p className="footprint-heading">Risky Ports</p>
                                        <p className="footprint-count">{formatNumber(riskFindingStats?.stats?.domain_risk_findings?.application_vulnerabilities?.risky_ports?.total)}</p>
                                    </div>
                                </div>                        
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <div className="findings-type-container">
                                    <h4 className="sub-heading">Infrastructure Configuration Risks</h4>
                                    <Row>
                                        <Col lg={3}>
                                            <div className="footprint-status w-100">
                                                <p className="footprint-heading">SSL Vulnerabilities</p>
                                                <p className="footprint-count">{formatNumber(riskFindingStats?.stats?.domain_risk_findings?.infrastructure_configuration_risks?.ssl_vulnerabilities?.total)}</p>
                                            </div>
                                        </Col>
                                        <Col lg={9}>
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="footprint-status critical">
                                                    <p className="footprint-heading">Criticals</p>
                                                    <p className="footprint-count">{formatNumber(riskFindingStats?.stats?.domain_risk_findings?.infrastructure_configuration_risks?.ssl_vulnerabilities?.critical)}</p>
                                                </div>
                                                <div className="footprint-status high">
                                                    <p className="footprint-heading">High</p>
                                                    <p className="footprint-count">{formatNumber(riskFindingStats?.stats?.domain_risk_findings?.infrastructure_configuration_risks?.ssl_vulnerabilities?.high)}</p>
                                                </div>
                                                <div className="footprint-status medium">
                                                    <p className="footprint-heading">Medium</p>
                                                    <p className="footprint-count">{formatNumber(riskFindingStats?.stats?.domain_risk_findings?.infrastructure_configuration_risks?.ssl_vulnerabilities?.medium)}</p>
                                                </div>
                                                <div className="footprint-status low">
                                                    <p className="footprint-heading">Low</p>
                                                    <p className="footprint-count">{formatNumber(riskFindingStats?.stats?.domain_risk_findings?.infrastructure_configuration_risks?.ssl_vulnerabilities?.low)}</p>
                                                </div>
                                            </div>                                    
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={5}>
                                <div className="findings-type-container">
                                    <h4 className="sub-heading">DNS Security</h4>
                                    <Row>
                                        <Col lg={5}>
                                            <div className="footprint-status w-100 pe-0">
                                                <p className="footprint-heading">Subdomain Takeover</p>
                                                <p className="footprint-count">{formatNumber(riskFindingStats?.stats?.domain_risk_findings?.dns_security?.subdomain_takeovers?.total)}</p>
                                            </div>
                                        </Col>
                                        <Col lg={7}>
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="footprint-status critical w-50">
                                                    <p className="footprint-heading">Confirmed</p>
                                                    <p className="footprint-count">{formatNumber(riskFindingStats?.stats?.domain_risk_findings?.dns_security?.subdomain_takeovers?.confirmed)}</p>
                                                </div>
                                                <div className="footprint-status high w-50">
                                                    <p className="footprint-heading">Potential</p>
                                                    <p className="footprint-count">{formatNumber(riskFindingStats?.stats?.domain_risk_findings?.dns_security?.subdomain_takeovers?.potential)}</p>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col lg={5}>
                                <div className="findings-type-container">
                                    <h4 className="sub-heading">Brand Insights</h4>
                                    <div className="d-flex align-items-center gap-3">
                                        <div className="footprint-status w-50">
                                            <p className="footprint-heading">Similar Domain</p>
                                            <p className="footprint-count">{formatNumber(riskFindingStats?.stats?.domain_risk_findings?.brand_insights?.similar_domains?.total)}</p>
                                        </div>
                                        <div className="footprint-status w-50">
                                            <p className="footprint-heading">High Similarity(&gt; 75%)</p>
                                            <p className="footprint-count">{formatNumber(riskFindingStats?.stats?.domain_risk_findings?.brand_insights?.similar_domains?.more_than_75_similarity)}</p>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={2}>
                                <div className="findings-type-container">
                                    <h4 className="sub-heading">Code Exposure</h4>
                                    <div className="footprint-status w-100">
                                        <p className="footprint-heading">Gitleaks</p>
                                        <p className="footprint-count">{formatNumber(riskFindingStats?.stats?.domain_risk_findings?.code_exposures?.gitleaks?.total)}</p>
                                    </div>
                                </div>                        
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={8}>
                                <div className="findings-type-container">
                                    <h4 className="sub-heading">Data Breach & Leak Intelligence</h4>
                                    <Row>
                                        <Col lg={4}>
                                            <div className="footprint-status w-100">
                                                <p className="footprint-heading">Leaked Credentials</p>
                                                <p className="footprint-count">{formatNumber(riskFindingStats?.stats?.domain_risk_findings?.data_breach_and_leak_intelligence?.leaked_credentials?.total)}</p>
                                            </div>
                                            <div className="expiry-count d-flex align-items-center justify-content-between">
                                                <p className="m-0">Last 90 days Count</p>
                                                <p className="m-0">{formatNumber(riskFindingStats?.stats?.domain_risk_findings?.data_breach_and_leak_intelligence?.leaked_credentials?._90_days)}</p>
                                            </div>
                                        </Col>
                                        <Col lg={4}>
                                            <div className="footprint-status w-100">
                                                <p className="footprint-heading">Botnet Infection</p>
                                                <p className="footprint-count">{formatNumber(riskFindingStats?.stats?.domain_risk_findings?.data_breach_and_leak_intelligence?.botnet_leaks?.total)}</p>
                                            </div>
                                            <div className="expiry-count d-flex align-items-center justify-content-between">
                                                <p className="m-0">Last 30 days Count</p>
                                                <p className="m-0">{formatNumber(riskFindingStats?.stats?.domain_risk_findings?.data_breach_and_leak_intelligence?.botnet_leaks?._30_days)}</p>
                                            </div>
                                        </Col>
                                        <Col lg={4}>
                                            <div className="footprint-status w-100">
                                                <p className="footprint-heading">Ransomware Group Leaks</p>
                                                <p className="footprint-count">{formatNumber(riskFindingStats?.stats?.domain_risk_findings?.data_breach_and_leak_intelligence?.ransomware_group_leaks?.total)}</p>
                                            </div>
                                            <div className="expiry-count d-flex align-items-center justify-content-between">
                                                <p className="m-0">Last 30 days Count</p>
                                                <p className="m-0">{formatNumber(riskFindingStats?.stats?.domain_risk_findings?.data_breach_and_leak_intelligence?.ransomware_group_leaks?._30_days)}</p>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </motion.div>
            }            
        </div>
    )
}

export default RiskFindings;